/**
 * Created by caoshi on 2017/9/8.
 */
import axios from "axios";
import AppConfig from "../appConfig";
//baseUrl
axios.defaults.baseURL = AppConfig.API.BASE_URL;
//timeout
axios.defaults.timeout = 60000;
axios.defaults.headers["abgf"] = "AUTH_TOKEN";
export default axios;



// WEBPACK FOOTER //
// ./src/factory-api/https.js